import React, { useRef, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { FiMoreVertical } from 'react-icons/fi';
import useOnClickOutside from 'use-onclickoutside';
import { useTranslation } from 'react-i18next';
import FixToWallImg from 'assets/images/ribbons/cabinetRibbon/fix_to_wall.png';
import NotFixToWallImg from 'assets/images/ribbons/cabinetRibbon/not_fix_to_wall.png';
import Img from '../../../../components/Img';
import { fixToWallAction } from './actions';
import { Cabinet } from '../../../../lib/modelBuilder/entities/Cabinet';
import { RootState } from '../../../CrossPiecePanel/types';
import { makeSelectLastHistoryCabinet } from '../../../Configurator/selectors/history';

interface StateProps {
  cabinet: Cabinet;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  cabinet: makeSelectLastHistoryCabinet(),
});

const CabinetOptions = () => {
  const [isOpen, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { cabinet } = useSelector(stateSelector);
  const { t } = useTranslation();
  const ref = useRef(null);
  useOnClickOutside(ref, () => {
    setOpen(false);
  });

  const hide = () => {
    setOpen(false);
  };

  return (
    <div className="relative text-main">
      <button
        onClick={() => {
          setOpen(!isOpen);
        }}
        className="mx-2"
      >
        <FiMoreVertical className="h-5 w-5" />
      </button>
      {isOpen && (
        <ul
          ref={ref}
          className="position right-0 top-0 -mt-6 absolute bg-white border border-gray-400 w-56 z-100"
        >
          <li className="flex justify-center text-lg italic font-light border-b border-gray-200">
            {t('Cabinet options')}
          </li>
          <li className="">
            <button
              onClick={() => {
                dispatch(fixToWallAction(!cabinet.isFixedToWall()));
                setOpen(false);
              }}
              className="flex items-center px-3 py-2 hover:bg-gray-200 w-full"
            >
              {cabinet.isFixedToWall() ? (
                <Img src={NotFixToWallImg} alt="doors" className="h-8 w-8" />
              ) : (
                <Img src={FixToWallImg} alt="doors" className="h-8 w-8" />
              )}
              <div className="ml-4">
                {cabinet.isFixedToWall()
                  ? t(`Don't fix to wall`)
                  : t('Fix to wall')}
              </div>
            </button>
          </li>
        </ul>
      )}
    </div>
  );
};

export default CabinetOptions;
